import { Checkbox } from '@chakra-ui/react';
import React from 'react';

import { COMMON_WEB_PATH } from '../../../constant';

const CustomCheckbox = (props) => {
  return (
    <Checkbox
      {...props}
      sx={{
        '& .chakra-checkbox__control': {
          bg: 'rgba(0, 0, 0, 0.4)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100% 100%',
          boxShadow:
            '0 0 8px cyan, 0 0 16px cyan, inset 0 0 6px rgba(0, 255, 255, 0.5)',
          borderColor: 'cyan.400',
          width: '25px',
          height: '25px',
          _checked: {
            bg: 'rgba(0, 0, 0, 0.4)',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% 100%',
            boxShadow:
              '0 0 8px cyan, 0 0 16px cyan, inset 0 0 6px rgba(0, 255, 255, 0.5)',
            borderColor: 'cyan.400',
            width: '25px',
            height: '25px',
            '& div': {
              backgroundImage: `url(${COMMON_WEB_PATH}/theOne/lng/lng_tick.png)`,
              w: '100%',
              bgRepeat: 'no-repeat',
              bgSize: 'contain'
            },
            '& svg': {
              display: 'none'
            }
          }
        }
      }}
    >
      {props.labelText}
    </Checkbox>
  );
};

export default CustomCheckbox;
